const FullWidthImage = () => {
	return (
		<svg
			width="14"
			height="15"
			viewBox="0 0 18 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.5 17V9.5H2V14.45L14.95 1.5H10V-4.76837e-07H17.5V7.5H16V2.55L3.05 15.5H8V17H0.5Z"
				fill="white"
			/>
		</svg>
	)
}

export default FullWidthImage
